import {
  FORM_CONSTANTS,
  FORM_MESSAGES
} from "@/shared/constants/FormConstants";
import lodash from "lodash";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import {
  DATA_TYPES,
  FILTERS_NAMES_CONST,
  DATA_CONDITIONS_TRANSFER,
  GENERAL_RULES_CONSTANTS,
  INPUT_TYPE,
  RULES_ACCESS,
  RULE_NEW,
  TABS
} from "../../constants/GeneralRulesConstants";
import { GeneralRulesService } from "../../services/GeneralRulesService";
import Actions from "../Actions/Actions.vue";
import Conditions from "../Conditions/Conditions.vue";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import { GeneralRule } from "../../models/GeneralRule";
import { ActionGeneralRules } from "../../models/actions.model";
import { ConditionRules } from "../../models/ConditionsRules.model";
import { Collection } from "../../models/Collection.model";
import { Http } from "@status/codes";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { RulesResponse } from "../../models/RulesResponse.model";
import { Response } from "@/shared/models/Response";
import { Utils } from "@/shared/utils/utils";
import { CupsPriceLevelHeader } from "@/modules/CupsPriceLevels/models/CupsPriceLevelHeader";
import {
  PANEL_INFO_CONSTANTS,
  STORE_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import store from "@/store";
import { HeaderUserTemplate } from "@/modules/UserTemplate/models/HeaderUserTemplate";
import { UserStatus } from "@/modules/User/models/UserStatus";
import { Dependency } from "@/modules/Dependencies/models/Dependency";
import Vuetify from "vuetify";
import { RecipientsConfiguration } from "@/modules/Notification/models/MessageRecipients";
import { AxiosError } from "axios";
import { ESCHEMA_TYPES } from "@/modules/FormTemplate/constants/FormTemplateConstants";
import { mapGetters } from "vuex";

Vue.use(Vuetify);
@Component({
  name: "SaveRules",
  components: {
    Actions,
    Conditions,
    ModalTemplate
  },
  computed: {
    ...mapGetters({
      medicalOrderStates: "getOrderStates"
    })
  }
})
export default class SaveGeneralRules extends Vue {
  @Inject() generalRulesService!: GeneralRulesService;

  @Prop() ruleToEdit!: GeneralRule;
  @Prop() newRule!: boolean;

  TABS = TABS;
  selectedTab: string = TABS.CONDITIONS;
  iconBtnClass = STYLE_CLASSES.ICON_BTN;
  PAGE_START = FORM_CONSTANTS.BUTTON.PAGE_START;
  CANCEL_BTN = FORM_CONSTANTS.BUTTON.CANCEL;
  SAVE_BTN = FORM_CONSTANTS.BUTTON.SAVE;
  disableSaveButton = true;
  fetchConditions = false;
  fetchActions = false;
  saveModal = false;
  conditions: Array<ConditionRules> = [];
  actions: Array<ActionGeneralRules> = [];
  rule: GeneralRule = RULE_NEW;
  collection: Collection = {
    key: "",
    name: "",
    fields: []
  };

  dataTransferActions = {
    collectionName: "",
    dataSelectKey: "",
    dataCondition: {
      key: "",
      name: ""
    }
  };
  actionsValidated = false;
  isToEdit = false;
  cardClass = STYLE_CLASSES.CARD;
  openActions = false;
  ACTIONS = GENERAL_RULES_CONSTANTS.TABS.ACCIONES;
  CONDITIONS = GENERAL_RULES_CONSTANTS.TABS.CONDICIONES;
  SAVE_MODAL_TITLE = FORM_MESSAGES.SAVE_MODAL.TITLE;
  SAVE_MODAL_TEXT = FORM_MESSAGES.SAVE_MODAL.MESSAGE;

  disableActionsTab = true;
  cupsStore: CupsPriceLevelHeader[] = [];
  ruleId = "";
  priceLvlsList: { keys: string[]; values: string[] } = {
    keys: [],
    values: []
  };
  keyIterator = 1;
  isValidRuleName = false;
  sessionServiceCon = false;
  editComparationStr = "";
  invalidEdit = false;
  conditionInvalidEdit = false;
  actionInvalidEdit = false;
  medicalOrderStates: any;

  mounted() {
    this.changeRule();
  }

  @Watch("ruleToEdit._key")
  changeRule() {
    this.keyIterator++;
    if (this.ruleToEdit._key) {
      this.disableActionsTab = false;
      this.editRule(this.ruleToEdit);
      this.changeTab(TABS.CONDITIONS);
      this.selectedTab = TABS.CONDITIONS;
      this.isValidRuleName = true;
      this.invalidEdit = true;
      this.actionInvalidEdit = true;
      this.conditionInvalidEdit = true;
    } else {
      this.disableSaveButton = true;
      this.selectedTab = TABS.CONDITIONS;
      this.openActions = false;
      this.disableActionsTab = true;
      this.isToEdit = false;
      this.ruleId = "";
      this.rule = this.ruleToEdit;
      this.isValidRuleName = false;
    }
    this.editComparationStr = JSON.stringify(this.rule);
  }

  changeTab(action: string) {
    this.selectedTab = action;
    this.selectDataOrder();

    if (action === TABS.ACTIONS && !this.openActions) {
      this.sessionServiceCon = this.checkSessionService();
      this.openActions = true;
    }
  }

  @Watch("newRule")
  cleanForms() {
    this.keyIterator++;
    this.disableActionsTab = true;
    this.ruleId = "";
  }

  handleModalCancel() {
    this.saveModal = false;
  }

  showSaveConfirmationModal() {
    this.saveModal = true;
  }

  async saveRule() {
    this.saveModal = false;
    const rule = { ...this.rule };

    try {
      rule.collection = this.collection?.key!;
      rule.conditions = this.rule.conditions.map(item => {
        const condition: ConditionRules = {
          key: "",
          operator: "",
          value: "",
          active: true,
          type: typeof item.value,
          timeUnit: item.timeUnit ? item.timeUnit : "",
          innerConditions: item.innerConditions ? item.innerConditions : []
        };
        const findField = this.collection?.fields.find(
          element => element.field === item.key
        );
        condition.key = findField !== undefined ? findField!.key : item.key;
        condition.operator =
          findField !== undefined
            ? findField!.operators.find(
                element => element.operator === item.operator
              )?.key!
            : item.operator;
        if (Array.isArray(item.value)) {
          condition.value =
            item.display === INPUT_TYPE.DATE_PICKER
              ? this.convertdateContidionsToMiliseconds(item.value)
              : item.value.map((element: any) => element.key);
        } else {
          if (item.display === INPUT_TYPE.DATE_PICKER) {
            condition.value = this.convertdateContidionsToMiliseconds(
              item.value
            );
          } else if (item.display === INPUT_TYPE.NUMBER) {
            condition.value = item.value;
          } else {
            condition.value = Object.prototype.hasOwnProperty.call(
              item.value,
              GENERAL_RULES_CONSTANTS.KEY
            )
              ? item.value.key
              : item.value;
          }
        }

        return condition;
      });

      const actionsToSave = [];
      const actionsArray = lodash.cloneDeep(this.rule.actions);

      for (let index = 0; index < actionsArray.length; index++) {
        const action = lodash.cloneDeep(actionsArray[index]);

        if (action.type === GENERAL_RULES_CONSTANTS.MEDICAL_ORDER) {
          if (action.medicalOrder?.cups && this.cupsStore.length > 0) {
            const findIdCup = this.cupsStore.find(
              cup =>
                cup.externalName === action.medicalOrder?.cups ||
                cup.id === action.medicalOrder?.cups
            );

            action.medicalOrder.cups = findIdCup?.id!;
          }

          if (action.medicalOrder) {
            action.medicalOrder.priceLevel = this.fixPriceLevelToSend(
              action.medicalOrder.priceLevel,
              action.medicalOrder.priceLevelKey!
            );

            if (this.openActions) {
              if (typeof action.medicalOrder?.state === "string") {
                let stateId = this.medicalOrderStates.find(
                  (state: { id: string; name: string }) =>
                    state.id === action.medicalOrder?.state
                )?.id;

                if (!stateId) {
                  stateId = this.medicalOrderStates.find(
                    (state: { id: string; name: string }) =>
                      state.name === action.medicalOrder?.state
                  )?.id;
                }
                action.medicalOrder.state = stateId;
              } else {
                action.medicalOrder.state = action.medicalOrder?.state?.id;
              }
            }
          }
        }
        if (action.type == GENERAL_RULES_CONSTANTS.TASK) {
          action.task!.recipients.dependencies =
            action.task!.recipients.dependencies.length &&
            typeof action.task!.recipients.dependencies[0] != DATA_TYPES.STRING
              ? (action.task!.recipients.dependencies as Dependency[]).map(
                  item => item.id ?? ""
                )
              : (action.task!.recipients.dependencies as string[]);

          action.task!.recipients.dependencyUsers =
            action.task!.recipients.dependencies.length &&
            typeof action.task!.recipients.dependencyUsers[0] !=
              DATA_TYPES.STRING
              ? (action.task!.recipients.dependencyUsers as UserStatus[]).map(
                  item => item.id ?? ""
                )
              : (action.task!.recipients.dependencyUsers as string[]);
        }
        actionsToSave.push(action);
      }

      rule.actions = actionsToSave;

      let response: Response<RulesResponse>;
      if (this.isToEdit) {
        response = await this.generalRulesService.updateRule(rule, rule._key!);
        this.sendDataToLateralMenu(
          PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM,
          ""
        );
      } else {
        response = await this.generalRulesService.saveRule(rule);
      }

      if (response.code === Http.Ok || response.code === Http.Created) {
        Snackbar.popSuccess(
          GENERAL_RULES_CONSTANTS.MESSAGES.REQUEST_SUCCESSFULLY
        );
        this.selectedTab = TABS.CONDITIONS;
        this.$emit(GENERAL_RULES_CONSTANTS.RULE_SAVE);
      } else {
        Snackbar.popError(response.message);
      }
    } catch (error) {
      const METHOD = Utils.getMethodHTTP(
        error as AxiosError
      ) as keyof typeof RULES_ACCESS;
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + RULES_ACCESS[METHOD]
        );
      else Snackbar.popError(GENERAL_RULES_CONSTANTS.MESSAGES.REQUEST_FAILED);
    }
  }

  fixPriceLevelToSend(priceLevel: any, priceLevelKey: string) {
    if (priceLevelKey) return priceLevelKey;
    if (priceLevel.key) return priceLevel.key;
    if (!(typeof priceLevel === ESCHEMA_TYPES.STRING) && !priceLevel.key)
      return "";
    return priceLevel;
  }

  mapRecipients(recipients: RecipientsConfiguration) {
    recipients.userTemplates = (recipients.userTemplates as HeaderUserTemplate[]).map(
      template => template._key
    );
    recipients.templateUsers = (recipients.templateUsers as UserStatus[]).map(
      user => user.id
    );
    recipients.dependencies = (recipients.dependencies as Dependency[]).map(
      dependency => (dependency.id ? dependency.id : "")
    );
    recipients.dependencyUsers = (recipients.dependencyUsers as UserStatus[]).map(
      user => user.id
    );
  }

  enableSaveButton() {
    this.fetchConditions = !this.fetchConditions;
  }

  isValidName(value: boolean) {
    this.isValidRuleName = value;
  }

  getActionsToSave() {
    if (this.isToEdit && !this.openActions) {
      this.disableSaveButton = false;
      return;
    }
    this.fetchActions = !this.fetchActions;
  }

  validateConditions(fieldsConditionsForm: any) {
    let conditionsOk = false;
    for (const item in fieldsConditionsForm) {
      if (item === GENERAL_RULES_CONSTANTS.CONDITIONS) {
        for (const element of fieldsConditionsForm[item]) {
          if (
            typeof element.value === DATA_TYPES.STRING &&
            element.value === ""
          ) {
            this.disableActionsTab = true;
            conditionsOk = false;
            break;
          }

          if (Array.isArray(element.value)) {
            if (element.value.length === 0 || element.value[0] === "") {
              this.disableActionsTab = true;
              conditionsOk = false;
              break;
            }
          }

          if (element.innerConditions && element.innerConditions.length > 0) {
            const findEmptyValue = (element.innerConditions as any[]).find(
              inner => {
                if (Array.isArray(inner.value)) {
                  return inner.value.length === 0;
                } else if (!inner.value) {
                  return true;
                }
              }
            );
            if (findEmptyValue !== undefined) {
              this.disableActionsTab = true;
              conditionsOk = false;
              break;
            }
          }
          this.disableActionsTab = false;
          conditionsOk = true;
        }
        if (conditionsOk) {
          continue;
        } else {
          break;
        }
      } else {
        if (fieldsConditionsForm[item] === "") {
          conditionsOk = false;
          break;
        }
      }
    }
    if (conditionsOk) {
      this.rule.collection = fieldsConditionsForm.collection;
      this.rule.name = fieldsConditionsForm.ruleName;
      this.rule.description = fieldsConditionsForm.ruleDescription;
      this.rule.conditions = fieldsConditionsForm.conditions;

      this.getActionsToSave();
      if (this.actionsValidated) {
        this.disableSaveButton = false;
      }
    } else {
      this.disableSaveButton = true;
    }
  }

  async validateActions(params: {
    actions: ActionGeneralRules[];
    cupsStore: CupsPriceLevelHeader[];
    priceLvlsList: { keys: string[]; values: string[] };
  }) {
    this.cupsStore = params.cupsStore;
    this.priceLvlsList = params.priceLvlsList;

    if (params.actions.length === 0) {
      this.disableSaveButton = true;
      this.actionsValidated = false;
    } else {
      this.rule.actions = lodash.cloneDeep(params.actions);
      this.actionsValidated = true;
      this.disableSaveButton = false;
    }
  }

  getCollection(event: Collection) {
    this.collection = event;
  }

  editRule(rule: GeneralRule) {
    this.ruleId = rule._key!;
    this.rule = rule;
    this.isToEdit = true;
  }

  onCloseModal() {
    this.$emit(FORM_MESSAGES.EVENT_BUTTON.CLOSE_MODAL);
  }

  enableRule() {
    this.rule.state = !this.rule.state;
  }

  goToStart(id: string) {
    Utils.scrollToElement(id, this);
  }

  sendDataToLateralMenu(action: string, data?: any) {
    store.commit(STORE_CONSTANTS.TO_LATERAL_MENU, {
      from: PANEL_INFO_CONSTANTS.FROM.CRUD,
      type: PANEL_INFO_CONSTANTS.TYPE.SEARCH,
      action: action,
      data: data
    });
  }

  convertdateContidionsToMiliseconds(dateValue: string | string[]) {
    if (Array.isArray(dateValue)) {
      const dateClone = [...dateValue];
      return dateClone.map(date => new Date(date).getTime());
    }
    return new Date(dateValue).getTime();
  }

  selectDataOrder() {
    this.dataTransferActions.dataSelectKey = "";
    this.dataTransferActions.dataCondition.key = "";
    this.dataTransferActions.dataCondition.name = "";

    this.dataTransferActions.collectionName = this.collection.key;
    this.rule.conditions.forEach(condition => {
      if (DATA_CONDITIONS_TRANSFER.indexOf(condition.key) > -1) {
        this.dataTransferActions.dataSelectKey = condition.key;
        this.dataTransferActions.dataCondition.key = condition.value[0].key;
        this.dataTransferActions.dataCondition.name = condition.value[0].name;
      }
    });
  }

  checkSessionService() {
    if (this.rule.collection == FILTERS_NAMES_CONST.SESSION.NAME) {
      const serviceCon = this.rule.conditions.find(
        condition =>
          condition.key == FILTERS_NAMES_CONST.SESSION.FIELDS.SERVICE.name
      );
      return serviceCon ? true : false;
    }
    return false;
  }
  checkConditionEdit(event: { equal: boolean }) {
    this.conditionInvalidEdit = event.equal;
    this.invalidEdit = this.actionInvalidEdit && event.equal;
  }
  checkActionEdit(event: { equal: boolean }) {
    this.actionInvalidEdit = event.equal;
    this.invalidEdit = this.conditionInvalidEdit && event.equal;
  }
}
